import { createFeature, createReducer, on } from '@ngrx/store';

import { addScannedCode, resetScannedCode } from './scanned-codes.actions';

export const scannedCodesFeatureKey = 'scannedCodes';

export interface ScannedCodeState {
    scannedCodes: { [token: string]: string };
}

export const initialState: ScannedCodeState = {
    scannedCodes: {},
};

export const reducer = createReducer(
    initialState,
    on(addScannedCode, (state, { token, code }) => ({
        ...state,
        scannedCodes: { ...state.scannedCodes, [token]: code },
    })),
    on(resetScannedCode, (state, { token }) => {
        const scannedCodes = { ...state.scannedCodes };
        delete scannedCodes[token];
        return {
            ...state,
            scannedCodes,
        };
    }),
);

export const scannedCodesFeature = createFeature({
    name: scannedCodesFeatureKey,
    reducer,
});
